/** Campos del elemento que viven en la raíz (escritorio), no en breakpoints. */
export const ELEMENT_DESKTOP_ROOT_KEYS = [
	"entryAnimation",
	"entryAnimationDuration",
	"registrationLocked",
	"registrationRole",
];

export function pickElementDesktopRootPatch(updated) {
	if (!updated || typeof updated !== "object") return {};
	const patch = {};
	for (const key of ELEMENT_DESKTOP_ROOT_KEYS) {
		if (updated[key] !== undefined) patch[key] = updated[key];
	}
	return patch;
}

/** Asegura campos de animación antes de enviar al API. */
export function normalizePagesForPersist(pages) {
	if (!Array.isArray(pages)) return [];
	return pages.map((page) => ({
		...page,
		elements: (page.elements || []).map((el) => {
			const dur = Number(el?.entryAnimationDuration);
			return {
				...el,
				entryAnimation: el?.entryAnimation || "none",
				entryAnimationDuration: Number.isFinite(dur) && dur > 0 ? dur : 500,
			};
		}),
	}));
}
